import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';

export interface Report {
  id: string;
  reporterId: string;
  reporterName: string;
  reportedType: 'artwork' | 'user' | 'comment';
  reportedId: string;
  reason: string;
  description: string;
  status: 'pending' | 'reviewing' | 'resolved' | 'dismissed';
  createdAt: Date;
}

export const createReport = async (
  reporterId: string,
  reporterName: string,
  reportedType: 'artwork' | 'user' | 'comment',
  reportedId: string,
  reason: string,
  description: string
) => {
  const reportData = {
    reporterId,
    reporterName,
    reportedType,
    reportedId,
    reason,
    description,
    status: 'pending',
    createdAt: Timestamp.now(),
  };

  const docRef = await addDoc(collection(db, 'reports'), reportData);
  return docRef.id;
};

export const getReports = async (status?: string): Promise<Report[]> => {
  let q = query(collection(db, 'reports'));
  
  if (status) {
    q = query(q, where('status', '==', status));
  }

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    createdAt: doc.data().createdAt?.toDate() || new Date(),
  })) as Report[];
};

export const updateReportStatus = async (reportId: string, status: Report['status']) => {
  const reportRef = doc(db, 'reports', reportId);
  await updateDoc(reportRef, { status });
};